import { useTranslation } from 'react-i18next';
import { InputAdornment, styled, TextField } from '@mui/material';
import { SvgSearchRegular } from '@insights-ltd/design-library/components';

type OrganisationSearchBoxProps = {
  value: string;
  onChange: (value: string) => void;
  placeholderKey?: string;
};

const StyledSearchIcon = styled(SvgSearchRegular)({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'text',
  transition: 'box-shadow 200ms',
});

const OrganisationsSearchBox = ({
  value,
  onChange,
  placeholderKey,
}: OrganisationSearchBoxProps) => {
  const { t } = useTranslation();

  let placeholder;

  if (placeholderKey) {
    placeholder = placeholderKey;
  } else {
    placeholder =
      'ui.event-management.organisations.search.placeholder.search-term';
  }

  return (
    <TextField
      sx={(theme) => ({ backgroundColor: theme.palette.common.white })}
      id="organisation-search"
      data-testid="OrganisationSearchInput"
      fullWidth
      variant="outlined"
      placeholder={t(placeholder)}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      slotProps={{
        input: {
          'aria-label': t(
            'ui.event-management.organisations.search.label.bold',
          ),
          startAdornment: (
            <InputAdornment position="start">
              <StyledSearchIcon />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
export default OrganisationsSearchBox;
